import { makePutRequest } from 'owa-ows-gateway';
import * as trace from 'owa-trace';
import ParsedReminder from '../store/schema/ParsedReminder';
import ReminderGroupTypes from 'owa-service/lib/contract/ReminderGroupTypes';
import { getUserConfiguration } from 'owa-session-store';
import getCallbackUrlBase from '../utils/getCallbackUrlBase';
import { timestamp, getTimestamp } from 'owa-datetime';
import sha256 from 'hash.js/lib/hash/sha/256';

const PUT_START_TIMER_URL: string = 'ows/beta/Timers/timer';
const REMINDER_PROCESSOR_API_URL = 'api/ReminderProcessor/processItem';

export default async function scheduleTimerForWebPushReminder(reminders: ParsedReminder[]) {
    // Filter the Calendar Reminders yet to happen
    const calendarReminders = reminders.filter(
        reminder =>
            reminder.ReminderGroupTypes === ReminderGroupTypes.Calendar &&
            getTimestamp(reminder.parsedReminderTime) > timestamp()
    );

    const timeZone = getUserConfiguration().UserOptions.TimeZone;
    calendarReminders.forEach(async calendarReminder => {
        try {
            // Start a new timer
            await makePutRequest(PUT_START_TIMER_URL, {
                timerName: sha256().update(calendarReminder.ItemId.Id).digest('hex'),
                payload: JSON.stringify({
                    id: calendarReminder.ItemId.Id,
                    timeZoneId: timeZone,
                }),
                callbackURL: getCallbackUrlBase() + REMINDER_PROCESSOR_API_URL,
                scheduledTime: calendarReminder.parsedReminderTime,
            });
        } catch (e) {
            trace.errorThatWillCauseAlert(`scheduleTimerForWebPushReminderFailure, error: ${e}`);
        }
    });
}
